__turbopack_context__.v({
  "profile-dropdown-client": "profile-dropdown-client-module-scss-module__iEMXYW__profile-dropdown-client",
  "profile-dropdown-client__content": "profile-dropdown-client-module-scss-module__iEMXYW__profile-dropdown-client__content",
  "profile-dropdown-client__popover": "profile-dropdown-client-module-scss-module__iEMXYW__profile-dropdown-client__popover",
  "profile-dropdown-client__trigger": "profile-dropdown-client-module-scss-module__iEMXYW__profile-dropdown-client__trigger",
  "slide-in": "profile-dropdown-client-module-scss-module__iEMXYW__slide-in",
  "slide-out": "profile-dropdown-client-module-scss-module__iEMXYW__slide-out",
});
